import { createSlice } from '@reduxjs/toolkit';
import { fetchPermissionCatalog, fetchUserPermissions } from './UserPermissions';

const permissionsSlice = createSlice({
  name: "permissions",
  initialState: {
    permissions: [],
    catalog: [],
    loading: false,
    catalogLoading: false,
    error: null,
    catalogError: null,
    loaded: false, 
    catalogLoaded: false,
  },
  reducers: {
    clearPermissions: (state) => {
      state.permissions = [];
      state.catalog = [];
      state.loaded = false; 
      state.catalogLoaded = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.permissions = action.payload;
        state.loaded = true; 
        state.error = null;
      })
      .addCase(fetchUserPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.loaded = false; 
      })
      .addCase(fetchPermissionCatalog.pending, (state) => {
        state.catalogLoading = true;
        state.catalogError = null;
      })
      .addCase(fetchPermissionCatalog.fulfilled, (state, action) => {
        state.catalogLoading = false;
        state.catalog = action.payload?.modules || action.payload || [];
        state.catalogLoaded = true;
        state.catalogError = null;
      })
      .addCase(fetchPermissionCatalog.rejected, (state, action) => {
        state.catalogLoading = false;
        state.catalog = [];
        state.catalogError = action.payload;
        state.catalogLoaded = false;
      });
  },
});


export const { clearPermissions } = permissionsSlice.actions;
export default permissionsSlice.reducer;
